import React, { Component } from 'react';

class QuickSearch extends Component {

  render() {
    return (
        <div className="quickSearchBlock">Zoek een bedrijf met RC/RO/RT in dienst</div>
    );
  }
}

export default QuickSearch;




// WEBPACK FOOTER //
// ./src/components/Global/Modules/QuickSearch.js